import Button from "@app/sharedComponents/Button/Button";
import { ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { formatIndianCurrency } from "@app/utils/utility";
import { Info } from '@sharedComponents/Icons/Icons';

const MonthlyInterest = ({openPrinicpalCard,closeBottomSheet,totalPrincipalOutStanding,dailyEMI,monthlyInterestEMI,annualInterestRate}) =>{
    return(
        <ThemedView p="lg">
            <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center" mb="2xl">
                <ThemedText variant="h5s" color='text-primary'>Monthly interest EMI</ThemedText>
            </ThemedView>
            <ThemedView
                flexDirection='row'
                alignItems="center"
                justifyContent="space-between"
                mb="lg"
                >
                <ThemedView flexDirection="row" alignItems="center">
                <ThemedText variant="b3r" color='text-primary'>
                    Total outstandings {' '}
                </ThemedText>
                <ThemedPressable onPress={openPrinicpalCard} mt="2xs" >
                    <Info size={14} />
                </ThemedPressable>
                </ThemedView>

                <ThemedText variant="b3r" color='text-primary'>
                    ₹{formatIndianCurrency(totalPrincipalOutStanding)}
                </ThemedText>
            </ThemedView>
            <ThemedView
                flexDirection='row'
                alignItems="center"
                justifyContent="space-between"
                >
                <ThemedText variant="b3r" color='text-primary'>
                    Daily interest @ {annualInterestRate}% p.a
                </ThemedText>
                <ThemedText variant="b3r" color='text-primary'>
                    ₹{formatIndianCurrency(dailyEMI)}
                </ThemedText>
            </ThemedView>
            <ThemedView height={1} backgroundColor="border-secondary" width={"100%"} my="lg" />
            <ThemedView
                flexDirection='row'
                alignItems="center"
                justifyContent="space-between"
                mb="2xl"
                >
                <ThemedText variant="b3s" color='text-primary'>
                   Monthly interest (for 30 days)
                </ThemedText>
                <ThemedText variant="b3s" color='text-primary'>
                    ₹{formatIndianCurrency(monthlyInterestEMI)}
                </ThemedText>
            </ThemedView>
            <Button label="Ok, got it!" type="SOLID" handlePress={closeBottomSheet}/>
        </ThemedView>
    )
}

export default MonthlyInterest;